import React, { memo } from 'react';
import styled from 'App/styled';
import { footerId } from 'components/ListingPage/Scroll/constants';
import AppLinks from './AppLinks';
import ContentForSearch from './ContentForSearch';
import Features from './Features';
import SocialMediaLinks from './SocialMediaLinks';
import Newsletter from './Newsletter';
import Navigation from './Navigation';
import Copyrights from './Copyrights';
import PriceList from './CategoryPriceList';
import Categories from './Categories';
import AboutUs from './AboutUs';
import QuickLinks from './QuickLinks';
import ContactUs from './ContactUs';
import PopularLinks from './PopularLinks';
import DynamicFooterLinks from './RelatedLinks';

const Wrapper = styled.footer<{ shouldLazyLoadSubComponent?: boolean }>`
  position: relative;
  width: 100%;
  background: ${(props) => props.theme.footerBak};
  ${({ shouldLazyLoadSubComponent }) =>
    shouldLazyLoadSubComponent && 'content-visibility: auto;'}
  ${({ theme }) => theme.typography.bodyMedium};
`;

const InfoContainer = styled.div`
  width: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing.spacing200} ${theme.spacing.spacing0}`};
  background-color: ${(props) => props.theme.newsletterBak};
`;

const Container = styled.div`
  width: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing.spacing200} ${theme.spacing.spacing0}`};
`;

const CategoryContainer = styled.div`
  width: 60%;
  padding-left: ${({ theme }) => theme.spacing.spacing50};
  padding-right: ${({ theme }) => theme.spacing.spacing50};
`;

const InfoWrapper = styled.div`
  max-width: 1200px;
  padding: ${({ theme }) =>
    `${theme.spacing.spacing0} ${theme.spacing.spacing160}`};
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;
const BottomContainer = styled.div`
  display: flex;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.textDecorative};
  justify-content: space-between;
`;
interface Props {
  shouldLazyLoadSubComponent?: boolean;
}

const Footer = ({ shouldLazyLoadSubComponent = true }: Props) => (
  <>
    <Wrapper
      id={footerId}
      shouldLazyLoadSubComponent={shouldLazyLoadSubComponent}
    >
      <InfoContainer>
        <InfoWrapper>
          <Newsletter shouldLazyLoadSubComponent={shouldLazyLoadSubComponent} />
          <AppLinks shouldLazyLoadSubComponent={shouldLazyLoadSubComponent} />
          <ContactUs />
        </InfoWrapper>
      </InfoContainer>
      <QuickLinks />
      <Container>
        <InfoWrapper>
          <Features />
          <SocialMediaLinks />
        </InfoWrapper>
      </Container>
      <ContentForSearch />
      <InfoWrapper>
        <BottomContainer>
          <CategoryContainer>
            <AboutUs />
            <Categories />
          </CategoryContainer>
          <PriceList />
        </BottomContainer>
      </InfoWrapper>
      <Navigation />
      <Copyrights />
      <PopularLinks />
      <DynamicFooterLinks />
    </Wrapper>
  </>
);

Footer.displayName = 'Footer';

export default memo(Footer);
